// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"f34376563272b89f8b57","452":"7cefd0465b057aeb47d0","453":"40317b93fd1b68b47b18","896":"1f3b149ac3b3cd3f1469"}[chunkId] + ".js";
};